module.exports = __webpack_public_path__ + "img/no-data.5fca38f9.png";